<template>
  <div class="ts-space-y-3">
    <!-- Total -->
    <div class="d-flex justify-content-between align-items-center">
      <span class="text-muted ts-text-xs">Total Advance</span>
      <strong class="text-primary">{{ totalAdvance }}</strong>
    </div>

    <!-- Existing records — always visible -->
    <Table
      :columns="columns"
      :data="records"
      size="small"
      stripe
      :loading="loading"
    />

    <!-- Add new row — only if not yet claimed -->
    <template v-if="!mission.is_claimed">
      <hr />
      <div class="row">
        <div class="col-md-12">
          <label class="ts-text-xs required">{{
            $t('employeeMission.advanceAmount')
          }}</label>
          <input
            v-model.number="newRow.advance_amount"
            type="number"
            class="form-control"
            placeholder="0"
          />
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12">
          <label class="ts-text-xs">{{ $t('employeeMission.remark') }}</label>
          <textarea
            v-model="newRow.remark"
            class="form-control"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div class="text-right ts-space-x-2 ts-mt-3">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
        <ts-button
          color="primary"
          :waiting="waiting"
          :disabled="waiting"
          @click.prevent="addRow"
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </template>

    <!-- Locked — only close button -->
    <template v-else>
      <hr />
      <div class="text-center text-muted ts-text-xs py-2">
        <i class="fas fa-lock mr-1"></i>
        {{ $t('employeeMission.alreadyClaimed') }}
      </div>
      <div class="text-right ts-mt-3">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
      </div>
    </template>
  </div>
</template>
<script>
import missionAdvanceRequest from '@/api/mission/mission-advance-request'

export default {
  name: 'AdvanceAddForm',
  props: {
    mission: { type: Object, required: true }
  },
  data() {
    return {
      loading: false,
      waiting: false,
      records: [],
      newRow: { advance_amount: 0, remark: '' }
    }
  },
  computed: {
    totalAdvance() {
      return this.records.reduce(
        (sum, r) => sum + parseFloat(r.advance_amount || 0),
        0
      )
    },
    columns() {
      return [
        { title: '#', type: 'index', width: 60, align: 'center' },
        {
          title: this.$t('employeeMission.advanceAmount'),
          key: 'advance_amount',
          align: 'right'
        },
        { title: this.$t('employeeMission.remark'), key: 'remark' }
      ]
    }
  },
  async mounted() {
    await this.loadRecords()
  },
  methods: {
    async loadRecords() {
      this.loading = true
      try {
        this.records = await missionAdvanceRequest.get(this.mission.id)
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    async addRow() {
      if (!this.newRow.advance_amount) return
      this.waiting = true
      try {
        await missionAdvanceRequest.store({
          mission_id: this.mission.id,
          advance_amount: this.newRow.advance_amount,
          remark: this.newRow.remark
        })
        this.$toasted.success('Added successfully')
        this.newRow = { advance_amount: 0, remark: '' }
        await this.loadRecords()
        this.$emit('updated')
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.waiting = false
      }
    }
  }
}
</script>
